/**
 * Protected Route Component
 */

import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { useAuth } from '../../auth/AuthContext';
import './ProtectedRoute.css';

interface ProtectedRouteProps {
    children: React.ReactNode;
    requireAuth?: boolean;
    redirectTo?: string;
}

const ProtectedRoute: React.FC<ProtectedRouteProps> = ({
    children,
    requireAuth = true,
    redirectTo = '/login',
}) => {
    const { isAuthenticated, isLoading, isInitialized } = useAuth();
    const location = useLocation();

    // Show loading while initializing
    if (!isInitialized || isLoading) {
        return (
            <div className="auth-loading">
                <div className="loading-container">
                    <div className="loading-spinner lg" />
                    <div className="loading-content">
                        <h2 className="loading-title">AIサイトパトローラー</h2>
                        <p className="loading-description">アプリケーションを読み込み中...</p>
                        <div className="loading-progress">
                            <div className="loading-progress-bar">
                                <div className="loading-progress-fill" />
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        );
    }

    // Redirect to login if authentication is required but user is not authenticated
    if (requireAuth && !isAuthenticated) {
        return (
            <Navigate
                to={redirectTo}
                state={{ from: location }}
                replace
            />
        );
    }

    // Redirect away from login if user is already authenticated
    if (!requireAuth && isAuthenticated) {
        const from = location.state?.from?.pathname || '/';
        return <Navigate to={from} replace />;
    }

    return <>{children}</>;
};

export default ProtectedRoute;
